import { createAction } from '../../../../store.model';
import { ActionType } from '../chat-menu-dialog.action';

export interface MinMax {
    minimized?: boolean;
}

export const minMax = createAction<ActionType, MinMax>(
    ActionType.TC__CM__MIN_MAX,
);
